import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'normalizePhoneNumber',
  standalone: false,
})
export class NormalizePhoneNumberPipe implements PipeTransform {
  public transform(value: string | null | undefined): string {
    if (!value) {
      return '';
    }

    // Remove non-digits except leading +
    const cleaned = value.replace(/[^\d+]/g, '');

    // Extract digits only
    const digits = cleaned.replace(/\D/g, '');

    // Extract last 10 digits (US local part)
    const local = digits.slice(-10);

    if (local.length !== 10) {
      return value; // Cannot normalize safely
    }

    // Determine country code
    let countryCode = '1'; // default

    if (cleaned.startsWith('+')) {
      // Count digits before last 10 digits
      const ccDigitsCount = digits.length - 10;

      if (ccDigitsCount > 0) {
        countryCode = digits.substring(0, ccDigitsCount);
      }
    }

    // Format last 10 digits
    const area = local.substring(0, 3);
    const prefix = local.substring(3, 6);
    const line = local.substring(6);

    return `+${countryCode} (${area}) ${prefix}-${line}`;
  }
}
